import { useEffect, useState } from 'react';
import { BookOpen, Play, Loader2 } from 'lucide-react';
import { Modal } from '../ui';
import { useTutorial } from '../../context/TutorialContext';
import { getActiveTutorials } from '../../services/tutorialsService';

function parseJson(str) {
    if (!str) return {};
    if (typeof str === 'object') return str;
    try { return JSON.parse(str); } catch { return {}; }
}

const TutorialSelector = ({ isOpen, onClose }) => {
    const { startTutorial } = useTutorial();
    const [tutorials, setTutorials] = useState([]);
    const [loading, setLoading] = useState(false);
    const lang = 'fr';

    useEffect(() => {
        if (!isOpen) return;
        (async () => {
            try {
                setLoading(true);
                const data = await getActiveTutorials(lang);
                setTutorials(data);
            } catch (err) {
                console.error('[TutorialSelector] load error', err);
            } finally {
                setLoading(false);
            }
        })();
    }, [isOpen]);

    const handleStart = async (uuid) => {
        onClose();
        await startTutorial(uuid);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Choisir un tutoriel"
            icon={BookOpen}
            hideFooter={true}
            size="md"
        >
            {loading ? (
                <div className="flex items-center justify-center py-8">
                    <Loader2 className="w-6 h-6 animate-spin text-purple-600" />
                </div>
            ) : tutorials.length === 0 ? (
                <p className="text-gray-500 text-center py-6 text-sm">
                    Aucun tutoriel disponible pour le moment.
                </p>
            ) : (
                <ul className="divide-y">
                    {tutorials.map(tut => {
                        const name = parseJson(tut.namebylang)[lang] || tut.code || '(sans nom)';
                        const desc = parseJson(tut.descriptionbylang)[lang] || '';
                        return (
                            <li key={tut.uuid} className="py-3 flex items-center justify-between gap-3">
                                <div className="flex-1 min-w-0">
                                    <div className="font-medium text-gray-900">{name}</div>
                                    {desc && <div className="text-xs text-gray-500 line-clamp-2">{desc}</div>}
                                    {tut.category && <div className="text-xs text-purple-600 mt-0.5">#{tut.category}</div>}
                                </div>
                                <button
                                    onClick={() => handleStart(tut.uuid)}
                                    className="inline-flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-lg hover:opacity-90 text-sm"
                                >
                                    <Play className="w-4 h-4" /> Démarrer
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </Modal>
    );
};

export default TutorialSelector;
